import React, { useMemo } from "react";

export default function AmbientBackground() {
  const dots = useMemo(() => Array.from({ length: 18 }, (_, i) => ({
    left: `${(i * 37) % 100}%`,
    duration: 18 + (i % 7) * 3,
    delay: -((i * 1.7) % 18),
    size: 3 + (i % 3),
  })), []);

  return (
    <>
      <div className="aurora" aria-hidden="true" />
      <div className="particles" aria-hidden="true">
        {dots.map((d, i) => (
          <span
            key={i}
            style={{
              left: d.left,
              width: `${d.size}px`,
              height: `${d.size}px`,
              animationDuration: `${d.duration}s`,
              animationDelay: `${d.delay}s`,
            }}
          />
        ))}
      </div>
    </>
  );
}
